import { v4 as uuidv4 } from 'uuid'

export default function HttpErrorResponseModel(status, message) {
  this.id = uuidv4()
  this.status = status
  this.message = message || 'Ocorreu um erro, tente novamente mais tarde.'
}
